import {Injectable} from '@angular/core';
import {Action, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {CoachGroupsListService} from './coach-groups-list.service';
import * as fromRoot from '../../../../state/app.state';
import {Observable, of} from 'rxjs';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import {FetchGroupsListModel} from '../models/fetch-groups-list.model';
import {
  ClearParticipantFilterRequest,
  FetchGroupFilterFailure,
  FetchGroupFilterRequest,
  FetchGroupFilterSuccess,
  FetchGroupsListFailure,
  FetchGroupsListRequest,
  FetchGroupsListSuccess,
  FetchGroupsStatusFilterFailure,
  FetchGroupsStatusFilterRequest,
  FetchGroupsStatusFilterSuccess,
  FetchGroupsTypeFilterFailure,
  FetchGroupsTypeFilterRequest,
  FetchGroupsTypeFilterSuccess,
  FetchParticipantFilterFailure,
  FetchParticipantFilterRequest,
  FetchParticipantFilterSuccess,
  GenerateAttendanceReportFailure,
  GenerateAttendanceReportRequest,
  GenerateAttendanceReportSuccess
} from './coach-groups-list.actions';
import {FetchGroupsTypeFilterModel} from '../models/fetch-groups-type-filter.model';
import {FetchGroupsStatusFilterModel} from '../models/fetch-groups-status-filter.model';
import {CommonService} from 'src/app/modules/shared/services/common.service';


@Injectable()
export class CoachGroupsListEffects {

  fetchGroupsList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupsListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload: FetchGroupsListModel['request']) =>
        this.groupsListService.fetchGroupsList(payload).pipe(
          map((response: FetchGroupsListModel['response']) => {
            const {data, message} = response;
            return FetchGroupsListSuccess({
              groupsList: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchGroupsListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchGroupsListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchGroupsListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  fetchGroupsTypeFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupsTypeFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.groupsListService.fetchGroupsTypeFilter().pipe(
          map((response: FetchGroupsTypeFilterModel['response']) => {
            const {data, message} = response;
            return FetchGroupsTypeFilterSuccess({
              groupsTypeFilter: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchGroupsTypeFilterFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchGroupsTypeFilterSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchGroupsTypeFilterFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  fetchGroupsStatusFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupsStatusFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.groupsListService.fetchGroupsStatusFilter().pipe(
          map((response: FetchGroupsStatusFilterModel['response']) => {
            const {data, message} = response;
            return FetchGroupsStatusFilterSuccess({
              groupsStatusFilter: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchGroupsStatusFilterFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchGroupsStatusFilterSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchGroupsStatusFilterFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  generateAttendanceReport$ = createEffect(() => this.actions.pipe(ofType(GenerateAttendanceReportRequest),
    map((action) => {
      this.commonService.startLoading();
      return  action.payload
    }),
    // mergeMap(payload => {
    //   this.commonService.startLoading();
    //   return this.groupsListService.fetchGroupsList(payload).pipe(map(response => {
    //     if (response.data.list.length > 0) {
    //       return response.data.list.map(item => item.id)
    //     } else {
    //       return []
    //     }
    //   }))
    // }),
    mergeMap(payload => {
      return this.groupsListService.generateAttendanceReport(payload).pipe(map(response => {
          this.commonService.notification('The report is getting prepared, you will receive it on your registered email ID', 'success')
          return GenerateAttendanceReportSuccess();
        }),
        catchError(err => of(GenerateAttendanceReportFailure())),
        tap((action: any) => {
          if (action.type === GenerateAttendanceReportSuccess.type) {
            this.commonService.closeDialog();
            // Code to execute on API Success Action dispatch
          } else if (action.type === GenerateAttendanceReportFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
          this.commonService.stopLoading();
        }))
    })
  ))

  fetchGroupsFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupFilterRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload: any) =>
        this.groupsListService.fetchGroupFilter(payload).pipe(
          map((response: any) => {
            const {data, message} = response;
            return FetchGroupFilterSuccess({payload: data});
          }),
          catchError(() => {
            return of(FetchGroupFilterFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchGroupFilterSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchGroupFilterFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  fetchParticipantsFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchParticipantFilterRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload: any) =>
        this.groupsListService.fetchParticipantFilter(payload).pipe(
          map((response: any) => {
            const {data, message} = response;

            return FetchParticipantFilterSuccess({payload: data});
          }),
          catchError(() => {
            return of(FetchParticipantFilterFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchParticipantFilterSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchParticipantFilterFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  constructor(
    private store: Store<fromRoot.State>,
    private groupsListService: CoachGroupsListService,
    private actions: Actions,
    private commonService: CommonService
  ) {
  }

}
